module.exports = __webpack_public_path__ + "static/img/20009 (6).dd3aa8f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20009 (6).webp
// module id = X4+v
// module chunks = 14